import * as React from "react";
import { TaxDeduction } from "../../../../TaxDeduction";
import { Modal } from "../../../../Modal";
import * as main from "../../styles/main.module.scss";
import * as cost from "./style.module.scss";

export const Cost = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={cost.cost}>
      <div className={main.containerFluid}>
        <div className={cost.get}>
          <div className={cost.getText}>
            При покупке любого из пакетов вы получаете <br/>
            доступ к флагманскому курсу «Учись Учиться» <br/>
            стоимостью 99&nbsp;900&nbsp;₽, на платформе которого <br/>
            будут проходить занятия.
          </div>
          <div className={cost.getVid}>
            <div className={cost.getVid__bg}>
              <iframe
                src="https://www.youtube.com/embed/EGrw3oQ2vXg"
                title={"2-минутное видеознакомство с курсом «Учись учиться»"}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <p className={cost.getVid__title}>2-минутное видеознакомство с курсом «Учись учиться»</p>
            <a href="#courseStructure" className={`${main.btn} ${cost.getBtn}`}>
              Подробнее про курс «Учись Учиться»
            </a>
          </div>
        </div>
        <div className={cost.buy}>
          <h2 className={`${main.titleH2} ${main.titleWhite}`}>
            Стоимость индивидуального обучения:
          </h2>
          <div className={cost.cardsWrap}>
            <div className={`${cost.card} ${cost.cardTrial}`}>
              <h3 className={cost.cardTitle}>
                Пакет<br/><span>«Пробный»</span>
              </h3>
              <ul className={cost.cardList}>
                <li className={cost.cardItem}>
                  <p className={cost.cardText}>
                    30 занятий
                  </p>
                </li>
                <li className={cost.cardItem}>
                  <p className={cost.cardText}>
                    300 000 &#8381;
                  </p>
                </li>
              </ul>
              <p className={`${cost.cardText} ${cost.cardTextGift}`}>
                Онлайн-курс «Учись Учиться» в подарок
              </p>
            </div>
            <div className={`${cost.card} ${cost.cardMotivation}`}>
              <h3 className={cost.cardTitle}>
                Пакет<br/><span>«Запускаем мотивацию»</span>
              </h3>
              <div className={cost.cardList}>
                <div className={cost.cardItem}>
                  <div className={cost.cardText}>
                    165 занятий
                  </div>
                </div>
                <div className={cost.cardItem}>
                  <div className={cost.cardText}>
                    1 500 000 &#8381;
                  </div>
                </div>
              </div>
              <div className={`${cost.cardText} ${cost.cardTextGift}`}>
                Онлайн-курс «Учись Учиться» в подарок
              </div>
            </div>
          </div>
          <TaxDeduction margin={"60px 0 0"} align={"center"}/>
          <button className={`${main.btn} ${cost.buyBtn}`} onClick={()=>{setShowModal(true)}}>
            Заказать консультацию по пакетам и обучению
          </button>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
